import React from 'react';
import { Row, Col, Space, Dropdown, Menu } from 'antd';
import Button from '@mui/material/Button';
import {DeleteOutlined, SearchOutlined} from '@ant-design/icons';
import { CloseRounded, MoreHorizRounded } from "@mui/icons-material";
import TickerChip from "../../../components/TickerChip";
import ColoredItem from "../../../components/ColoredItem";


const EtfHeader = ({
  name,
  symbol,
  logoUrl,
  onRemove,
  onCheck,
  isChecked = false,
  color,
  holdingsCount,
  handleColorUpdate,
}) => {

  const menu = (
    <Menu>
      <Menu.Item key="1">
        <ColoredItem label={''} color={color} onUpdateColor={(color) => handleColorUpdate(color)} />  Edit
      </Menu.Item>
      <Menu.Item key="2" onClick={onCheck}>
        {isChecked ? <><CloseRounded /> Stop Comparing</> : <><SearchOutlined /> Compare Holdings to Other ETFs</>}
      </Menu.Item>
      <Menu.Item key="3" onClick={onRemove}>
        <DeleteOutlined /> Remove All
      </Menu.Item>
    </Menu>
  );

  return (
    <Row className={'pt-2'} justify="space-between" align="top" gutter={[2, 16]}>
      <Col span={24}>
        <Row justify="space-between" align="middle" wrap={false}>
          {/* ETF Title with Dropdown Menu */}
          <TickerChip ticker={{ logo: logoUrl, name, symbol }} titleSuffix={`(${holdingsCount})`} />
          <Space>
            {/* Ellipsis Dropdown Menu */}
            <Dropdown overlay={menu} trigger={['click']}>
              <Button size={'small'}>
                <MoreHorizRounded />
              </Button>
            </Dropdown>
          </Space>
        </Row>
      </Col>
    </Row>
  );
};

export default EtfHeader;
